import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/app/tools/body-fat-calculator/page-client.tsx");
